__turbopack_context__.v({
  "Active": "sidebar-branches-accordion-module__66jpPa__Active",
  "ButtonContainer": "sidebar-branches-accordion-module__66jpPa__ButtonContainer",
  "Content": "sidebar-branches-accordion-module__66jpPa__Content",
  "Removed": "sidebar-branches-accordion-module__66jpPa__Removed",
  "Sublist": "sidebar-branches-accordion-module__66jpPa__Sublist",
  "Visible": "sidebar-branches-accordion-module__66jpPa__Visible",
  "fadeIn": "sidebar-branches-accordion-module__66jpPa__fadeIn",
  "fadeOut": "sidebar-branches-accordion-module__66jpPa__fadeOut",
});
